// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"dropdown_dropdown__3dt0N","suggestions":"dropdown_suggestions__eBcnZ","active":"dropdown_active__J1WOh"};